import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { BlogRedirectService } from './blog-redirect.service';
import { Observable } from 'rxjs/internal/Observable';
import { IBlog } from 'src/app/blog/blog.interface';

export const blogRedirectResolver: ResolveFn<Observable<IBlog>> = (route: ActivatedRouteSnapshot) => {
  return inject(BlogRedirectService).getBlog(route.params['slug']);
}
